import { DEFAULT_TAX_ROUNDING_STRATEGY, TaxConfiguration } from '@breezy/shared'
import { usePrincipalUser } from '../../providers/PrincipalUser'

export const useCompanyCurrentTaxConfiguration = (): TaxConfiguration => {
  const principalUser = usePrincipalUser()
  const principal = principalUser?.principal
  const company = principal?.company
  const currentTaxConfiguration = company?.currentTaxConfiguration
  const defaultTaxConfiguration = {
    roundingStrategy: DEFAULT_TAX_ROUNDING_STRATEGY,
  }

  const finalTaxConfiguration = currentTaxConfiguration ?? defaultTaxConfiguration

  return finalTaxConfiguration as TaxConfiguration
}
